<template>
  <div class="login-container">
    <div class="login-card">
      <h2>BVDP Steuerungscockpit</h2>
      <form @submit.prevent="handleLogin">
        <div class="form-group">
          <label for="username">Benutzername</label>
          <input
            id="username"
            v-model="username"
            type="text"
            class="form-control"
            required
            :disabled="loading"
          />
        </div>
        <div class="form-group">
          <label for="password">Kennwort</label>
          <input
            id="password"
            v-model="password"
            type="password"
            class="form-control"
            required
            :disabled="loading"
          />
        </div>
        <p v-if="error" class="login-error">{{ error }}</p>
        <button type="submit" :disabled="loading">
          {{ loading ? 'Anmelden…' : 'Einloggen' }}
        </button>
      </form>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import { getApiBaseUrl } from '@/config';

export default {
  name: 'LoginPage',
  data() {
    return {
      username: '',
      password: '',
      loading: false,
      error: null
    };
  },
  methods: {
    async handleLogin() {
      this.loading = true;
      this.error = null;
      try {
        const { data } = await axios.post(`${getApiBaseUrl()}/login/`, {
          username: this.username,
          password: this.password
        });
        if (data.success) {
          localStorage.setItem('username', data.username || data.usernameuser || this.username);
          const modules = Array.isArray(data.access_modules) ? data.access_modules : ['financial'];
          const role = data.user_role || '';
          if ((role === 'admin' || modules.includes('marketing')) && !modules.includes('financial') && role !== 'admin') {
            this.$router.push({ name: 'marketing-overview' });
          } else {
            this.$router.push({ name: 'dashboard' });
          }
        } else {
          this.error = 'Benutzername oder Kennwort falsch.';
        }
      } catch {
        this.error = 'Anmeldung fehlgeschlagen. Bitte versuche es erneut.';
      } finally {
        this.loading = false;
      }
    }
  }
};
</script>

<style scoped>
.login-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  background-image: url('@/assets/background_login.jpg');
  background-size: cover;
  background-position: center;
}

.login-card {
  background: rgba(255, 255, 255, 0.9);
  padding: 24px;
  border-radius: 10px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  max-width: 400px;
  width: 100%;
}

h2 {
  text-align: center;
  margin-bottom: 20px;
}

.form-group {
  margin-bottom: 16px;
}

label {
  display: block;
  margin-bottom: 4px;
}

.login-error {
  color: var(--color-negative);
  font-size: 0.875rem;
  margin-bottom: 12px;
}

button {
  width: 100%;
  padding: 10px;
  background: var(--color-primary);
  color: white;
  border: none;
  border-radius: 5px;
  cursor: pointer;
}

button:hover:not(:disabled) {
  background: var(--color-primary-dark);
}

button:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}
</style>
